module.exports = __webpack_public_path__ + "img/chat.427de97b.png";